import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './components/Root';
import './styles/styles.scss';

const root = createRoot(document.getElementById('app'));
root.render(<Root />);
